"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const glightbox_1 = __importDefault(require("glightbox"));
const Localize_1 = __importDefault(require("./Localize"));
const surveyAccess = document.querySelector('.js-survey');
let StaffRequirements = {
    supportRequired: false,
    initialize: function () {
        if (surveyAccess && surveyAccess.getAttribute('data-survey-access') === '1') {
            let surveyUrl = surveyAccess.getAttribute('data-survey-url');
            if (surveyUrl) {
                const lightbox = new glightbox_1.default({
                    selector: null
                });
                let http = new XMLHttpRequest();
                http.open('GET', surveyUrl, true);
                http.onreadystatechange = function () {
                    if (http.readyState == 4 && http.status == 200) {
                        lightbox.insertSlide({
                            width: '700px',
                            height: 'auto',
                            content: http.response
                        });
                        lightbox.on('open', () => {
                            function setFocus() {
                                let element = document.querySelector('.ginlined-content .formelement__radio-label');
                                element.focus();
                            }
                            setFocus();
                        });
                        lightbox.open();
                        let surveySupport = document.querySelector('.js-staff-requirements__support');
                        if (surveySupport) {
                            surveySupport.style.display = 'none';
                        }
                        let closeBtn = document.querySelector('.js-staff-requirements-close');
                        if (closeBtn) {
                            closeBtn.addEventListener('click', function () {
                                lightbox.close();
                            });
                        }
                        let requirementsRadios = Array.from(document.querySelectorAll('.js-formelement__input--requirements'));
                        let surveyRadios = Array.from(document.querySelectorAll('.js-formelement__input--support'));
                        if (requirementsRadios && surveyRadios) {
                            requirementsRadios.forEach(function (requirementsRadio) {
                                requirementsRadio.addEventListener('click', function () {
                                    if (this.value === 'none') {
                                        if (surveySupport) {
                                            surveySupport.style.display = 'none';
                                            surveySupport.setAttribute('aria-hidden', 'true');
                                            surveyRadios.forEach(function (surveyRadio) {
                                                surveyRadio.checked = false;
                                                StaffRequirements.supportRequired = false;
                                            });
                                        }
                                    }
                                    else {
                                        if (surveySupport) {
                                            surveySupport.style.display = 'block';
                                            surveySupport.setAttribute('aria-hidden', 'false');
                                            StaffRequirements.supportRequired = true;
                                        }
                                    }
                                });
                            });
                        }
                        let surveyForm = document.querySelector('.js-staff-requirements-form');
                        if (surveyForm) {
                            surveyForm.addEventListener('submit', function (e) {
                                e.preventDefault();
                                let selectedRequirementsRadio = document.querySelector('.js-formelement__input--requirements:checked');
                                let selectedSupportRadio = document.querySelector('.js-formelement__input--support:checked');
                                if (selectedRequirementsRadio && (StaffRequirements.supportRequired === false || selectedSupportRadio)) {
                                    let formData = new FormData(surveyForm);
                                    let httpPost = new XMLHttpRequest();
                                    httpPost.open('POST', surveyForm.getAttribute('action') + '&type=78', true);
                                    httpPost.onreadystatechange = function () {
                                        if (http.readyState == 4 && http.status == 200) {
                                            lightbox.setElements([
                                                {
                                                    content: httpPost.response
                                                },
                                            ]);
                                            let closeBtn = document.querySelector('.js-staff-requirements-close');
                                            if (closeBtn) {
                                                closeBtn.addEventListener('click', function () {
                                                    lightbox.close();
                                                });
                                            }
                                        }
                                    };
                                    httpPost.send(formData);
                                }
                                else {
                                    let errorWrapper = document.querySelector('.js-formelement__help-block');
                                    if (!selectedRequirementsRadio) {
                                        errorWrapper.innerHTML = '<p>' + (0, Localize_1.default)('js.error.required') + '</p>';
                                    }
                                    else {
                                        errorWrapper.innerHTML = '<p>' + (0, Localize_1.default)('js.error.type_of_support_required') + '</p>';
                                    }
                                }
                            });
                        }
                    }
                };
                http.send();
            }
        }
    }
};
StaffRequirements.initialize();
